<button mat-flat-button color="primary" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
  [matMenuTriggerFor]="menu">
  <span>{{buttonName}}</span>
  <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
  @for (option of menuOptions; track trackByNavOption($index, option)) {
    @if (!option.subOptions?.length) {
      <a mat-menu-item [routerLink]="option.route">
        {{option.name}}
      </a>
    } @else {
      <button mat-menu-item type="button" [matMenuTriggerFor]="subMenu">
        {{option.name}}
      </button>
      <mat-menu #subMenu="matMenu">
        @for (subOption of option.subOptions; track trackBySubOption($index, subOption)) {
          <a mat-menu-item [routerLink]="subOption.route">
            {{subOption.name}}
          </a>
        }
      </mat-menu>
    }
  }
</mat-menu>
